import React from 'react';
import { useRouter } from 'next/router';
import { ChatbotGrayGateCore } from './ChatbotGrayGateCore';
import type { ChatbotGrayGateProps } from './types';

/**
 * Pages Router 版 ChatbotGrayGate：locale 来自 next/router。
 * App Router 项目（blofin-home）请使用 ./ChatbotGrayGate.app。
 */
export function ChatbotGrayGate(props: ChatbotGrayGateProps) {
  const { locale } = useRouter();
  return <ChatbotGrayGateCore {...props} locale={locale ?? 'en'} />;
}
